import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useLms } from '../context/LmsContext';
import { canAccessRole } from '../utils/navigation';

export function RequireAuth() {
  const { currentUser } = useLms();
  const location = useLocation();
  if (!currentUser) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <Outlet />;
}

export function RequireRole({ role }) {
  const { currentUser } = useLms();
  if (!currentUser) return <Navigate to="/login" replace />;
  if (!canAccessRole(currentUser, role)) return <Navigate to="/unauthorized" replace />;
  return <Outlet />;
}
